<template>
  <v-container class="py-4">
    <v-form ref="form" v-model="valid">
      <v-row v-if="internalMember">
        <v-col cols="12" md="6" class="py-0">
          <no-autocomplete-textfield
            disabled
            outlined
            :label="
              $t(
                'components.registration_completion.contacts_form.email_readonly'
              )
            "
            v-model="internalMember.EmailAddress"
            :rules="[$rules.required, $rules.email]"
            class="required highlight"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <no-autocomplete-textfield
            clearable
            outlined
            :label="
              $t(
                'components.registration_completion.contacts_form.secondary_email'
              )
            "
            v-model="internalMember.SecondaryEmail"
            :rules="[$rules.email]"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <no-autocomplete-textfield
            clearable
            outlined
            :label="
              $t(
                'components.registration_completion.contacts_form.mobile_phone'
              )
            "
            v-model="internalMember.MobilePhone"
            v-mask="telephoneMask"
            :rules="[rules.phone, rules.atLeastOnePhone]"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <no-autocomplete-textfield
            clearable
            outlined
            :label="
              $t('components.registration_completion.contacts_form.home_phone')
            "
            v-model="internalMember.HomePhone"
            v-mask="telephoneMask"
            :rules="[rules.phone, rules.atLeastOnePhone]"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-select
            outlined
            :label="
              $t(
                'components.contact_information_expansion_panel.preferred_phone'
              )
            "
            v-model="internalPreferredPhone"
            :items="preferredPhone"
            :disabled="phoneSelectDisabled"
            :rules="
              internalMember.HomePhone || internalMember.MobilePhone
                ? [$rules.required]
                : []
            "
            :class="
              internalMember.HomePhone || internalMember.MobilePhone
                ? 'required'
                : ''
            "
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select
            outlined
            :label="
              $t('components.registration_completion.contacts_form.language')
            "
            v-model="internalMember.Language"
            :items="languages"
            item-value="value"
            :item-text="$vuetify.lang.current === 'en' ? 'textEn' : 'textFr'"
            :rules="[$rules.required]"
            class="required"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select
            outlined
            :label="
              $t(
                'components.registration_completion.contacts_form.communication'
              )
            "
            v-model="internalMember.Communication"
            :rules="[$rules.required]"
            :items="enumModels.CommunicationPreference"
            class="required"
            :item-text="$vuetify.lang.current === 'en' ? 'textEn' : 'textFr'"
            item-value="value"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import NoAutocompleteTextfield from "@/components/controls/NoAutocompleteTextfield.vue";
import { mapGetters } from "vuex";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
export default {
  components: { NoAutocompleteTextfield },
  props: {
    member: Object,
    saving: Boolean,
  },
  directives: { mask },
  data() {
    return {
      dateMenu: false,
      internalMember: undefined,
      internalPreferredPhone: null,
      valid: false,
      languages: [
        { value: "English", textEn: "English", textFr: "Anglais" },
        { value: "French", textEn: "Français", textFr: "Français" },
      ],
      telephoneMask: "(###) ### - ####",
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
        atLeastOnePhone: () =>
          !!(
            this.internalMember?.MobilePhone || this.internalMember?.HomePhone
          ) || this.$t("validation.at_least_one_phone_is_required"),
      },
    };
  },
  computed: {
    ...mapGetters("common", ["enumModels", "identityUser"]),
    ...mapGetters("auth", ["user"]),
    preferredPhone() {
      const en = [
        {
          text: "Mobile",
          value: "Mobile",
        },
        {
          text: "Home",
          value: "Home",
        },
      ];
      const fr = [
        {
          text: "Mobile",
          value: "Mobile",
        },
        {
          text: "Téléphone",
          value: "Home",
        },
      ];
      return this.$vuetify.lang.current === "fr" ? fr : en;
    },
    phoneSelectDisabled() {
      return !(
        this.internalMember?.MobilePhone && this.internalMember?.HomePhone
      );
    },
    preferredPhoneAutoAssigned() {
      if (this.internalMember?.MobilePhone && !this.internalMember?.HomePhone)
        return "Mobile";
      if (!this.internalMember?.MobilePhone && this.internalMember?.HomePhone)
        return "Home";
      return null;
    },
  },
  watch: {
    member: {
      async handler(v) {
        if (v && this.internalMember === undefined) {
          this.loadMember(v);
        }
      },
      deep: true,
    },
    internalMember: {
      handler(v) {
        this.$emit("update-member", v);
      },
      deep: true,
    },
    internalPreferredPhone: {
      handler(v) {
        this.internalMember.PreferredPhone = v;
      },
    },
    valid: {
      handler(v) {
        this.$emit("update-valid", v);
      },
    },
    "internalMember.MobilePhone"(v) {
      if (!v && this.internalPreferredPhone === "Mobile") {
        this.internalPreferredPhone = this.internalMember.HomePhone
          ? "Home"
          : null;
      } else if (v && !this.internalMember.HomePhone) {
        this.internalPreferredPhone = "Mobile";
      }
      this.$nextTick(() => this.$refs.form?.validate());
    },
    "internalMember.HomePhone"(v) {
      if (!v && this.internalPreferredPhone === "Home") {
        this.internalPreferredPhone = this.internalMember.MobilePhone
          ? "Mobile"
          : null;
      } else if (v && !this.internalMember.MobilePhone) {
        this.internalPreferredPhone = "Home";
      }
      this.$nextTick(() => this.$refs.form?.validate());
    },
  },
  mounted() {
    if (this.member) {
      this.loadMember(this.member);
    }
    this.$refs.form.validate();
  },
  methods: {
    loadMember(v) {
      v.EmailAddress = this.identityUser.Email;
      v.Communication = "Email";
      this.internalMember = v;
      if (!this.internalMember.PreferredPhone) {
        this.internalPreferredPhone = this.preferredPhoneAutoAssigned;
      }
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
  },
};
</script>
<style scoped>
.camera-btn {
  right: 25px;
  top: 25px;
  position: relative;
}
.avatar {
  border: 3px white solid;
}
.v-input--is-disabled >>> input {
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-input--is-disabled >>> label {
  color: rgba(0, 0, 0, 0.87) !important;
}

.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.1) !important;
}
.v-tooltip__content {
  max-width: 150px !important;
}
</style>
